import './App.css';
import routes from './routes/Routes.js';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Popup from './components/Popup.jsx';
import { useEffect, useState } from 'react';
import TrackProvider from './contexts/track.context.tsx';

function App() { 
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
    };
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleOpenPopup = () => {
    setIsPopupOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="App">
      <TrackProvider>
        <HashRouter basename="/">
          <Navbar onOpenPopup={handleOpenPopup}/>
          <div className='main-app-container'>
          <Routes>
            {routes.map(({ path, component, exact }) => (
              <Route key={path} path={path} element={component} exact={exact} />
            ))}
          </Routes>
          </div>
          <Footer />
          {isPopupOpen && <Popup onClose={handleClosePopup} />}
        </HashRouter>
      </TrackProvider>
    </div>
  );
}

export default App;